export default __webpack_public_path__ + "media/images/nzws/transparent-044ef629a322001a6d1b1f9175ea24db.png";